import React from 'react';
import { highlights } from '../data/site';
import { Icon } from '../utils/icons';
export function Highlights() {
  return <section className="w-full bg-white" aria-label="Why work with us" data-id="element-67" data-mp="3mz8krnlwtzh3">
      <div className="mx-auto max-w-7xl px-6 py-16 lg:py-20" data-id="element-68" data-mp="3rqrqnk2pbvlh">
        <div className="grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-4" data-id="element-69" data-mp="3rtm7z2qf50ao">
          {highlights.map(item => <div key={item.title} data-id="element-70" data-mp="300df3ui5uvcz">
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-navy/5" data-id="element-71" data-mp="30159x33xop27">
                <Icon name={item.icon} className="h-6 w-6 text-gold" data-id="element-72" data-mp="342gtaqw7se1y" />
              </span>
              <h3 className="mt-5 font-display text-base font-extrabold uppercase tracking-wide text-navy" data-id="element-73" data-mp="38zqqispuhu0c">
                {item.title}
              </h3>
              <p className="mt-2 text-[15px] leading-relaxed text-gray-600" data-id="element-74" data-mp="3dxiljvlsdw8r">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}